import { render, staticRenderFns } from "./tabHelpApply.vue?vue&type=template&id=315dfea4&"
import script from "./tabHelpApply.vue?vue&type=script&lang=ts&"
export * from "./tabHelpApply.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports